<template>
    <defaultSec class="ai-robot-knowledge" v-loading="loading">
            <div style="display:flex;justify-content: space-between;padding: 0 10px">
                <div>智能知识库提炼</div>
                <div style="display: flex">
                    <el-input
                        style="width: 200px"
                        placeholder="请输入关键词"
                        @change="(val)=>handleChange(val,'keyword')"
                        v-model="formParam.keyword" size="mini" />
                    <el-date-picker
                        @change="(val)=>handleChange(val,'date')"
                        style="margin:0 5px"
                        size="mini"
                        v-model="formParam.date"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                    <el-select
                        @change="(val)=>handleChange(val,'qwUserId')"
                        clearable filterable v-model="formParam.qwUserId" placeholder="请选择客服" size="mini">
                        <el-option
                            v-for="item in userList"
                            :key="item.agentId"
                            :label="item.agentName"
                            :value="item.agentId">
                        </el-option>
                    </el-select>
                </div>

            </div>
            <div class="main-content">
                <div class="chat-list">
                    <div class="chat-list-header">
                        <h2>客户服务对话</h2>
                        <div class="chat-tabs">
                            <div class="chat-tab" v-for="item in chatTabs"
                                 :class="{active: formParam.status===item.status}"
                                 @click="handleChange(item.status,'status')">
                                {{ item.statusName }}</div>
                        </div>
                    </div>

                    <div class="chat-items">
                        <div v-for="chat in chats" :key="chat.id" class="chat-item" :class="{selected: chat.id===selectedChatId}" @click="selectChat(chat)">
                            <div class="chat-item-header">
                                <div class="chat-participants">{{ chat.chatPerson }}</div>
                                <div class="chat-time">{{ chat.chatDate }}</div>
                            </div>
                            <div class="chat-preview">{{ chat.chatContent }}</div>
                            <div class="chat-metrics">
                                <div class="metric pending" v-if="chat.qaPending>0">
                                    <i class="el-icon-message-solid"></i>
                                    <span>{{ chat.qaPending }} 待处理</span>
                                </div>
                                <div class="metric new" v-if="chat.qaAdopted>0">
                                    <i class="el-icon-s-flag"></i>
                                    <span>{{ chat.qaAdopted }} 已采用</span>
                                </div>
                                <div class="metric duplicate" v-if="chat.qaIgnored>0">
                                    <i class="el-icon-copy-document"></i>
                                    <span>{{ chat.qaIgnored }} 已忽略</span>
                                </div>
                            </div>
                            <div class="chat-tags">
                                <div class="chat-tag tag-sales" v-for="tag in chat.tags" :key="tag">{{ tag }}</div>
                            </div>
                        </div>
                        <el-empty v-if="chats.length===0" description="暂无数据"></el-empty>
                    </div>
                    <div style="display:flex;justify-content: flex-end">
                        <el-pagination
                            hide-on-single-page
                            @current-change="handleCurrentChange"
                            :page-size="formParam.pageSize"
                            :current-page.sync="formParam.currentPage"
                            small
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>

                <div class="editor">
                    <div class="editor-header">
                        <h2>知识提炼工作台<el-tag size="mini" v-if="selectedChatName" style="margin-left: 10px" type="success">{{selectedChatName}}</el-tag></h2>
                    </div>
                    <div style="overflow: auto" v-if="currentChat.chatList.length>0">
                        <div class="ai-suggestion-header">
                            <h3>
                                <i class="el-icon-chat-line-round" style="color: #1e88e5;"></i>
                                聊天对话内容
                            </h3>
                        </div>
                        <div class="chat-content">
                            <template v-for="(m,idx) in currentChat.chatList">
                                <div class="message" :class="m.speakType==2?'customer':'staff'">
                                    <div class="message-sender">{{ m.speakType==2?m.customerName:m.serviceName }} {{m.msgTime}}</div>
                                    <div class="message-bubble" v-html="m.content"></div>
                                </div>
<!--                                <div class="message staff">-->
<!--                                    <div class="message-sender">{{ m.serviceName }} {{m.msgTime}}</div>-->
<!--                                    <div class="message-bubble">{{ m.answer }}</div>-->
<!--                                </div>-->
                            </template>
                            <el-empty v-if="currentChat.chatList.length===0" description="暂无数据"></el-empty>

                        </div>

                        <div class="ai-suggestions">
                            <div class="ai-suggestion-header">
                                <h3>
                                    <i class="el-icon-service" style="color: #1e88e5;"></i>
                                    AI生成的问答对建议
                                </h3>
                                <el-button type="danger" size="mini" icon="el-icon-plus" @click="addNewQA"> 添加新问答对</el-button>
                            </div>
                            <el-tabs type="border-card">
                                <el-tab-pane
                                    :key="index"
                                    v-for="(item, index) in currentChat.detail"
                                    :label="item.title"
                                    :name="item.name"
                                >
                                    <template #label>
                                        <template v-if="item.qaStatus==1">
                                            <span style="color: #1bb263"><i class="el-icon-success"/> 已采用</span>
                                        </template>
                                        <template v-else-if="item.qaStatus==2">
                                            <span style="color: #f57c00"><i class="el-icon-copy-document"/> 已忽略</span>
                                        </template>
                                        <template v-else>
                                            <span style="color: #F56C6C;font-size: 12px"><i class="el-icon-message-solid"/> 待处理</span>
                                        </template>
                                    </template>
                                    <div class="ai-suggestion-item" :class="item.qaId&&item.type==1?'':'suggestion-duplicate'" :key="index">

                                        <div class="suggestion-header">
                                            <div class="suggestion-confidence">
                                                <i class="el-icon-star-on"></i>
                                                <span>{{ item.type==1?'AI生成':'人工添加' }}</span>
                                                <span>( {{ item.qaStatus==0?'待处理':(item.qaStatus==1?'已采用':'已忽略') }} )</span>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>问题</label>
                                            <el-input placeholder="请输入问题" v-model="item.question" size="mini"></el-input>
                                        </div>
                                        <div class="form-group">
                                            <label>答案</label>
                                            <el-input placeholder="请输入答案" type="textarea" :autosize="{minRows:3}" v-model="item.answer" size="mini"></el-input>
                                        </div>
                                        <div class="form-group">
                                            <label>问题分类</label>
                                            <el-cascader
                                                :disabled="item.qaId?true:false"
                                                v-model:value="item.category"
                                                clearable
                                                placeholder="试试搜索：订单"
                                                :options="categoryOptions"
                                                :props="{ label: 'category',value:'category' }"
                                                filterable />
                                        </div>
                                        <div class="form-group">
                                            <label>标签</label>
                                            <el-input :disabled="item.qaId?true:false" v-model="item.tag" placeholder="输入标签，用逗号分隔" size="mini"></el-input>
                                        </div>
                                        <div class="suggestion-actions" v-if="item.qaStatus==0">
                                            <template v-if="item.qaId">
                                                <el-button type="primary" size="mini" @click="useSuggestion(item, 1)">使用</el-button>
                                                <el-button size="mini" @click="useSuggestion(item,2)">忽略</el-button>
                                            </template>
                                            <el-button v-else type="primary" size="mini" @click="saveQA(item,index)">保存</el-button>
                                        </div>
                                    </div>

                                </el-tab-pane>
                            </el-tabs>
                            <el-empty v-if="currentChat.detail.length===0" description="暂无数据"></el-empty>

                        </div>

                    </div>
                    <el-empty v-if="currentChat.chatList.length===0" description="暂无数据"></el-empty>

                </div>
            </div>
    </defaultSec>
</template>

<script>
    import defaultSec from '@c/defaultSection'
    export default {
        name: 'ex',
        components: { defaultSec },
        data() {
            return {
                loading: true,
                formParam: {
                    qwUserId:'',
                    status:0,
                    currentPage: 1,
                    pageSize: 50,
                    date:[new Date().Format("yyyy-MM-dd"), new Date().Format("yyyy-MM-dd")]
                },
                chatTabs:[],
                userList: [],
                categoryOptions: [],
                chats: [],
                selectedChatId: '',
                selectedChatName: '',
                currentChat: {
                    chatList:[],
                    detail:[]
                },
                total:0
            }
        },
        mounted(){
            this.initData()
            this.initOptions()
        },
        methods: {
            initData(){
                this.loading = true
                let {date,...param} = {...this.formParam}
                param.startDate = date?date[0]:''
                param.endDate = date?date[1]:''
                this.$apiGet('lechun-ai/daily/init/sidebar', { ...param}).then(res => {
                    console.log(res)
                    this.loading = false
                    this.chats = res.converList.list.list||[]
                    this.total = res.converList.list.total||0
                    this.userList = res.kefuList||[]
                    this.chatTabs = res.statusList||[]
                    if (this.chats.length > 0) {
                        this.selectedChatId = this.chats[0].id
                        this.selectedChatName = this.chats[0].chatPerson
                        this.currentChat = {
                            chatList:this.chats[0].chatList||[],
                            detail:(this.chats[0].detail||[]).map(item => {
                                item.category = [item.categoryLevel1, item.categoryLevel2]
                                return item
                            })
                        }
                    }else{
                        this.selectedChatId = ''
                        this.selectedChatName = ''
                        this.currentChat = {
                            chatList:[],
                            detail:[]
                        }
                    }
                }).catch(err => {
                    this.loading = false
                })
            },
            initOptions(){
                this.$apiGet('lechun-ai/daily/getOptionList', {}).then(res => {
                    console.log(res)
                    this.categoryOptions = res.categoryTree || []
                })
            },
            saveQA(qa,i){
                let param = {
                    chatDailyId:this.selectedChatId,
                    question: qa.question,
                    answer: qa.answer,
                    category1: qa.category.length>0?qa.category[0]:'',
                    category2: qa.category.length>1?qa.category[1]:'',
                    tags: qa.tag
                }
                this.$apiGet('lechun-ai/daily/qa/add', {...param}).then(res => {
                    this.$set(this.currentChat.detail,i,res)
                    this.$message({ message: '已保存成功', type: 'success' })
                })
            },
            selectChat(chat){
                this.selectedChatId = chat.id
                this.selectedChatName = chat.chatPerson
                this.currentChat = {
                    chatList:chat.chatList||[],
                    detail:(chat.detail||[]).map(item => {
                        item.category = [item.categoryLevel1, item.categoryLevel2]
                        return item
                    })
                }
            },
            useSuggestion(sg, optimize){
                let param = {
                    qaId:sg.qaId,
                    qaStatus:optimize,
                    question: sg.question,
                    answer: sg.answer,
                }
                this.$apiGet('lechun-ai/daily/qa/save', {...param}).then(res => {
                    console.log(res)
                    this.$message({ message: optimize==1?'已使用':'已忽略', type: 'success' })
                })
            },
            handleChange( value,type){
                console.log( value,type)
                this.formParam.currentPage = 1
                if (type=='status') {
                    this.formParam.status = value
                } else if (type=='date') {
                    this.formParam.startDate = value?value[0]:''
                    this.formParam.endDate = value?value[1]:''
                } else if (type=='qwUserId') {
                    // this.formParam.qwUserId = value
                }
                this.initData()
                console.log(this.formParam)
            },
            handleCurrentChange(val){
                console.log( val,this.formParam)
                this.initData()
            },
            addNewQA(){
                this.currentChat.push({qaStatus:0})
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
.ai-robot-knowledge{
    .default-body{
        margin: 0!important;
        padding: 10px 0!important;
        background: #f6f6f6!important;
        height: calc(100% - 1px)!important;
    }
    .main-content{
        display: flex;
        flex: 1;
        gap: 10px;
        height: calc(100vh - 200px);
        padding: 10px 10px 10px 0;

    }
    .chat-list {
        width: 400px;
        flex-shrink: 0;
        background: white;
        border-radius: 12px;
        padding: 0 10px 10px 10px;
        box-shadow: 0 0 12px rgba(0,0,0,0.05);
        display: flex;
        flex-direction: column;
        height: calc(100vh - 146px);
        overflow-y: scroll;
        .chat-list-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0;
            h2 {
                font-size: 18px;
                color: #1a1a1a;
                margin: 10px 0;
            }
        }
        .chat-tabs {
            display: flex;
            gap: 10px;
            .chat-tab {
                padding: 4px 14px;
                background: #f0f4f8;
                border-radius: 20px;
                font-size: 14px;
                cursor: pointer;
                &.active { background: #1e88e5; color: white; }
            }
        }
        .chat-items { flex: 1; overflow-y: auto; }
    }

    .chat-item {
        padding: 10px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
        transition: background 0.2s;
        &:hover { background: #f9fafb; }
        &.selected { background: #e3f2fd; border-left: 4px solid #1e88e5; }
        .chat-item-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
            .chat-participants { font-weight: 500; color: #1e88e5; }
            .chat-time { color: #888; font-size: 14px; }
        }
        .chat-preview { color: #666; font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-bottom: 8px; }
        .chat-metrics {
            display: flex;
            gap: 15px;
            font-size: 13px;
            .metric { display: flex; align-items: center; gap: 4px; }
            .metric.pending { color: #F56C6C; }
            .metric.new { color: #43a047; }
            .metric.duplicate { color: #f57c00; }
        }
        .chat-tags { display: flex; gap: 6px; margin-top: 8px; }
        .chat-tag { padding: 3px 8px; border-radius: 12px; font-size: 12px; }
    }

    .tag-sales { background: #e8f5e9; color: #43a047; }
    .tag-support { background: #ffebee; color: #e53935; }
    .tag-logistics { background: #e3f2fd; color: #1e88e5; }

    .editor {
        display: flex;
        flex-direction: column;
        height: calc(100vh - 146px);
        flex: 1;
        background: white;
        border-radius: 12px;
        padding: 0 10px 10px 10px;
        box-shadow: 0 0 12px rgba(0,0,0,0.05);
        overflow-y: scroll;
        .el-textarea__inner,.el-input__inner{
            color: #000000;
            font-size: 14px;
            padding: 10px;
        }
        .editor-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0;
            h2 {
                font-size: 18px;
                color: #1a1a1a;
                margin: 10px 0;
            }
        }
        .chat-content {
            flex: 1;
            overflow-y: auto;
            padding: 15px;
            background: #f9fafb;
            border-radius: 8px;
            margin-bottom: 20px;
            max-height: 300px;
            .message {
                margin-bottom: 15px;
                max-width: 80%;
            }
            .message.customer {
                margin-right: auto; }
            .message.staff {
                margin-left: auto;
            }

            .message-bubble {
                padding: 12px 16px;
                border-radius: 18px;
                white-space: pre-line;
            }
            .customer {
                .message-bubble {
                    background: #e3f2fd;
                    border-top-left-radius: 4px;
                }
            }
            .staff {
                .message-bubble {
                    background: #48aae6;
                    color: white;
                    border-top-right-radius: 4px;
                }
            }

            .message-sender {
                font-size: 12px;
                margin-bottom: 4px;
                color: #666;
                padding: 0 8px;
            }
        }
    }

    .ai-suggestions { margin: 20px 0; }
    .ai-suggestion-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        margin-bottom: 15px;
        h3 {
            font-size: 16px;
            color: #1e88e5;
            margin: 2px 0;
        }
    }

    .ai-suggestion-item {
        background: #f1f8e9;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 15px;
        border-left: 4px solid #8bc34a;
        .suggestion-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
        .suggestion-confidence { display: flex; align-items: center; gap: 4px; font-size: 13px; color: #689f38; }
        .suggestion-actions { display: flex; gap: 10px; margin-top: 15px; }
    }
    .suggestion-duplicate { background: #fff3e0; padding: 8px 12px; border-radius: 6px; font-size: 13px; margin: 10px 0; border-left: 3px solid #ff9800; }

    .knowledge-form { display: flex; flex-direction: column; gap: 15px; }
    .form-group { display: flex; flex-direction: column; gap: 8px; }
    .form-group { label { font-size: 14px; font-weight: 500; color: #333; } }

    .category-select {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .category-pill {
            padding: 6px 12px;
            background: #f0f4f8;
            border-radius: 16px;
            font-size: 13px;
            cursor: pointer;
            &.selected { background: #1e88e5; color: white; }
        }
    }

    .form-actions { display: flex; gap: 10px; justify-content: flex-end; margin-top: 10px; }


}

//@media (max-width: 1400px) {
//    .editor { flex: 0 0 500px; }
//}

//@media (max-width: 1200px) {
//    .main-content { flex-direction: column; height: auto; }
//    .filters, .editor { flex: 0 0 auto; }
//    .chat-list { min-height: 400px; }
//}
</style>
